<script lang="ts">
  import { onMount } from "svelte";

  import CanaryBanner from "./ui/CanaryBanner.svelte";
  import Onboarding from "./ui/Onboarding.svelte";
  import DashboardStub from "./ui/DashboardStub.svelte";
  import { ConnectorManager } from "./sync/connector-manager.svelte";

  /**
   * The dashboard runs against a singleton {@link ConnectorManager} for the
   * life of the SPA. We construct it once at bootstrap, populate from
   * persistent storage, and pass it down to {@link DashboardStub}.
   *
   * Going through the manager (not the credential record directly) is what
   * lets multiple linked accounts coexist: the dashboard sees a merged peer
   * view, the link/create flows just append a new credential and call
   * `await manager.bootstrap()`.
   */
  const manager = new ConnectorManager();

  let bootstrapping = $state(true);

  /**
   * Reactive derivation off `manager.connectors`: as soon as a disconnect
   * empties the list (or a sign-out wipes everything), this flips back to
   * `false` and the SPA re-renders {@link Onboarding}. Without reading the
   * manager reactively, the dashboard would stay mounted with zero
   * connectors after the user disconnects their last sync source.
   */
  const hasAnyConnector = $derived(manager.connectors.length > 0);

  async function reload() {
    await manager.bootstrap();
  }

  onMount(async () => {
    try {
      await reload();
    } finally {
      bootstrapping = false;
    }
  });
</script>

<CanaryBanner />

<main>
  {#if bootstrapping}
    <p style="opacity: 0.6;">Loading…</p>
  {:else if hasAnyConnector}
    <DashboardStub {manager} onSignOut={reload} />
  {:else}
    <Onboarding onDone={reload} />
  {/if}
</main>
